import { SET_HEADERS } from "./mutation-types";

const mutations = {
  [SET_HEADERS](state, { type, data }) {
    state[`${type}`] = data;
  },
};

export default mutations;
